'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCogZoomed, iconCogZoomedTag } from '@ni/nimble-components/dist/esm/icons/cog-zoomed';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCogZoomed };
export { iconCogZoomedTag };
export const NimbleIconCogZoomed = wrap(IconCogZoomed);